import React from 'react'
import './sidebar.css'
import TopLogo from '../Parcial/TopLogo'
import Clock from '../Parcial/Clock'
import Logout from '../Parcial/Logout'
import Navigtion from '../Parcial/Navigtion'
import Create from '../Parcial/Create'
import ProjectFilters from '../Parcial/ProjectFilters'
import SideBarProjectsMob from '../Parcial/SideBarProjectsMob'
import Utils from '../Parcial/Utils'


function SideBarProjects() {
  return (
    <>
    <div className='sideBar'>
      <div className="sideBar2">
        <TopLogo />
        <Navigtion />
        <ProjectFilters />
        <Create />
        <Utils />
        <Clock />
        <Logout />
        </div>
    </div>
    <div className="sideBarMob">
      <SideBarProjectsMob />
    </div>
    </>
  )
}

export default SideBarProjects